import { render } from "./SimpleContextualInfo.vue?vue&type=template&id=1a38d3ef"
import script from "./SimpleContextualInfo.vue?vue&type=script&lang=js"
export * from "./SimpleContextualInfo.vue?vue&type=script&lang=js"

import "./SimpleContextualInfo.vue?vue&type=style&index=0&id=1a38d3ef&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import QFab from 'quasar/src/components/fab/QFab.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QField,QFab});
